<template>
  <div
    v-if="progress"
    class="o-progress"
  >
    <div
      :style="{ transform: `scaleX(${progress})` }"
      class="o-progress__indicator"
    ></div>
  </div>
</template>
<script>
  import { numberWithin } from '@/shared/utils';

  const MIN_PROGRESS = 0;
  const MAX_PROGRESS = 100;

  export default {
    props: {
      product: Object,
    },
    computed: {
      progress() {
        const progress = numberWithin(MIN_PROGRESS, MAX_PROGRESS, this.product.bookmark?.progress || this.product.progress);

        if (!isNaN(progress)) {
          return progress / 100;
        }

        return 0;
      },
    },
  };
</script>
